import { render, staticRenderFns } from "./ScriptedEventDecoderFields.vue?vue&type=template&id=c534bf74&"
import script from "./ScriptedEventDecoderFields.vue?vue&type=script&lang=ts&"
export * from "./ScriptedEventDecoderFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports